// extracted by mini-css-extract-plugin
module.exports = {"read-more":"TextTruncated_read-more__28NYm","read-less":"TextTruncated_read-less__1IPuq"};